import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import classNames from 'classnames';
import { IconButton } from '@material-ui/core';
import InputOutlined from '@material-ui/icons/InputOutlined';

import { logout } from '../utils';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  seperator: {
    width: 1,
    height: 64,
    backgroundColor: theme.palette.divider,
  },
});

class MainToolbar extends Component {
  async logout() {
    logout();
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classNames(classes.root, 'flex flex-row')}>
        <div className="flex flex-1 px-24" />

        <div className="flex" style={{ marginRight: '2em' }}>
          <IconButton variant="contained" color="primary" onClick={this.logout}>
            <InputOutlined />
          </IconButton>
        </div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(MainToolbar);



// WEBPACK FOOTER //
// ./src/main/MainToolbar.js